import type { Choice } from '@monthio/react-components/dist/MultipleChoice'

import { FlowPage } from '@monthio/design-system'
import { FormMultipleChoice } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'

import type { StepComponent } from './steps'

import { Transition } from '../budgetHelperStateMachine'
import { Step } from './Step'
import { MultipleChoiceWrapper, useStyles } from './StepMultipleChoice'

export const ChildrenSelectorStep: StepComponent = ({
	handleClick,
	formProps,
}) => {
	const classes = useStyles()
	const { t } = useTranslation()

	const numberOfChildren = Array.from({ length: 9 }, (_, i) => i)

	const choices: Choice[] = numberOfChildren.map((x) => ({
		value: x,
		label: x.toString(),
	}))

	choices[8]!.label = '8+'

	const onChoiceClick = (event: any) => {
		const value = parseInt(event.target.value)
		formProps.setFieldValue('childrenAges', [])
		handleClick(value === 0 ? Transition.End : Transition.Next)
	}

	return (
		<FlowPage>
			<FlowPage.Content $spacing="l">
				<FlowPage.Header title={t('budgetHelper-numberOfChildren-text')} />
				<Step>
					{() => (
						<MultipleChoiceWrapper $columns={3}>
							<FormMultipleChoice
								id="childrenInHousehold"
								fieldName="childrenInHousehold"
								choices={choices}
								className={`${classes.root} ${classes.button}`}
								choiceAlign="center"
								onClick={onChoiceClick}
								selected={formProps.values.childrenInHousehold?.toString()}
							/>
						</MultipleChoiceWrapper>
					)}
				</Step>
			</FlowPage.Content>
		</FlowPage>
	)
}
